export var appFramework = function appFramework(config) {
  if (!config.framework) {
    return null;
  }
  return {
    'app:framework:name': config.framework.name,
    'app:framework:version': config.framework.version
  };
};